<template>
    <div class="flex-column">
        <v-toolbar class="shadow-none" content-class="h-auto">
            <div class="d-flex align-items-center">
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_ManageTemplates") }}</v-toolbar-title>
            </div>
            <v-spacer></v-spacer>
        </v-toolbar>

        <div class="border-top p-4 flex-1 d-flex flex-column overflow-auto">
            <v-layout wrap>
                <div class="flex-1">
                    <v-text-field v-model="searchField" :placeholder="$t('res_Label_TemplateName')" @keyup="getTemplates"
                        solo></v-text-field>
                </div>
                <div class="actions d-flex">
                    <v-btn class="primary" @click="OpenAddNewTemplateDialog()">{{ $t("res_ButtonText_AddTemplate")
                    }}</v-btn>
                </div>
            </v-layout>
            <div class="flex-1 mb-2">
                <Pagination :totalCount="pagingData.totalCount" :pageSize="pagingData.pageSize"
                    :pageIndex="pagingData.pageIndex" @pageIndexChanged="pageIndexChanged"></Pagination>
            </div>

            <v-data-table id="templateList" class="position-relative white h-100 d-flex flex-column"
                :headers="templateHeaders" :items="templates" hide-default-footer :items-per-page="pagingData.pageSize"
                disable-sort :no-data-text="$t('res_Label_NoData')">
                <template v-slot:item="row" item-key="id">
                    <tr @mouseover="selectItem(row.item)" @mouseleave="unSelectItem()">
                        <td style="display: none">{{ row.item.id }}</td>
                        <td>{{ row.item.name }}</td>
                        <td>{{ row.item.category }}</td>
                        <td>{{ row.item.fileSize }}</td>
                        <td>{{ row.item.createdDate }}</td>
                        <td>
                            <div class="onhover-display">
                                <div class="custom-icon-wrapper">
				                <v-icon @click="openPreviewTemplateDialog(row.item.id)">mdi-file-document</v-icon>
                                </div>
                                <div class="custom-icon-wrapper">
                                    <v-icon @click="openEditTemplateDialog(row.item)">custom-icon white-bg
                                        edit-icon</v-icon>
                                </div>
                                <div class="custom-icon-wrapper" v-if="row.item.isWorkflow">
                                    <v-icon @click="openAdvanceTemplateEdit(row.item.id)">custom-icon white-bg
                                        settings-outline-icon gear-icon</v-icon>
                                </div>
                                <div class="custom-icon-wrapper">
                                    <v-icon @click="openTemplateDelegionDialog(row.item.id)">custom-icon white-bg
                                        delete-icon</v-icon>
                                </div>

                                <div class="custom-icon-wrapper" v-if="constants.client_version_Id != 'ADNOC'">
                                    <v-icon @click="openTemplateReplaceDialog(row.item.id)">mdi-file-replace</v-icon>
                                </div>
                                <div class="custom-icon-wrapper" v-if="constants.client_version_Id != 'ADNOC'">
                                    <v-icon @click="downloadTemplate(row.item.id)">mdi-download</v-icon>
                                </div>
                                <div class="custom-icon-wrapper" v-if="constants.client_version_Id != 'ADNOC' || constants.client_version_Id != 'DGS'">
                                    <v-icon @click="showDynamicFormBuilderComponent(row.item.id)">mdi-format-float-none</v-icon>
                                </div>

                            </div>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>

						
		<v-dialog fullscreen content-class="fullscreen-dialog" v-model="showPreviewTemplateDialog">
			<TemplatePreview :templateId="templateId" :closeDialogFunc="closePreviewTemplateDialog"/>  
		</v-dialog> 

        <v-dialog v-model="showAddNewTemplateDialog" content-class="small-dialog" width="600">
            <v-card>
                <v-card-title>{{ $t("res_DialogTitle_AddNewTemplate") }}</v-card-title>
                <div class="card-body">
                    <label>{{ $t("res_Label_Category") }}<span style="color: red"> *</span></label>
                    <Multiselect v-model="category" label="name" track-by="id" open-direction="bottom"
                        :placeholder="$t('res_Label_Select')" :options="categories" :searchable="true" :loading="loading"
                        :internal-search="false" dense :clear-on-select="true" :close-on-select="true" :options-limit="300"
                        :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false" outlined>
                    </Multiselect>
                    <br />

                    <label>{{ $t("res_Label_TemplateName") }}<span style="color: red"> *</span></label>
                    <v-text-field v-model="templateName" label="" solo></v-text-field>
                    <br />

                    <label>{{ $t("res_Label_AttachTemplate") }}<span style="color: red"> *</span></label>
                    <v-file-input accept=".docx" label="" solo v-model="templateFile" prepend-icon=""></v-file-input>
                    <br />
                </div>

                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" @click="showAddNewTemplateDialog = false">{{ $t("res_ButtonText_Cancel")
                    }}</v-btn>
                    <v-btn class="primary" @click="addNewTemplate()">{{ $t("res_ButtonText_Submit") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showEditTemplateDialog" content-class="small-dialog" width="600">
            <v-card>
                <v-card-title>{{ $t("res_DialogTitle_EditTemplate") }}</v-card-title>
                <div class="card-body overflow-auto">
                    <div class="row">
                        <div class="col-md-6">
                            <label>{{ $t("res_Label_Category") }}<span style="color: red"> *</span></label>
                            <Multiselect class="light-bg" v-model="category" label="name" track-by="id"
                                open-direction="bottom" :placeholder="$t('res_Label_Select')" :options="categories"
                                :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false"
                                :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false"
                                :hide-selected="false" :multiple="false">
                            </Multiselect>
                        </div>
                        <div class="col-md-6">
                            <label>{{ $t("res_Label_Privacy") }}<span style="color: red"> *</span></label>
                            <Multiselect class="light-bg" v-model="privacy" label="name" track-by="id"
                                open-direction="bottom" :placeholder="$t('res_Label_Select')" :options="privacies"
                                :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false"
                                :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false"
                                :hide-selected="false" :multiple="false">
                            </Multiselect>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label>{{ $t("res_Label_TemplateName") }}<span style="color: red"> *</span></label>
                            <v-text-field v-model="templateName" label="" solo></v-text-field>
                        </div>
                        <div class="col-md-6">
                            <label>{{ $t("res_Label_SignatureCount") }}<span style="color: red"> *</span></label>
                            <v-text-field v-model="signatureCount" type="number" label="" solo></v-text-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label class="ml-1">{{ $t("res_Label_Tags") }}</label>
                            <v-text-field v-model="tags" label="" solo></v-text-field>
                        </div>
                        <div class="col-md-6">
                            <label class="ml-1">{{ $t("res_Label_TagsArabic") }}</label>
                            <v-text-field v-model="tagsAr" label="" solo></v-text-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label class="ml-1">{{ $t("res_Label_Description") }}</label>
                            <v-textarea v-model="description" label="" solo></v-textarea>
                        </div>
                        <div class="col-md-6">
                            <label class="ml-1">{{ $t("res_Label_DescriptionArabic") }}</label>
                            <v-textarea v-model="descriptionAr" label="" solo></v-textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <label class="ml-1">{{ $t("res_Label_Workflow") }}</label>
                            <v-checkbox v-model="isWorkflow" label="" solo></v-checkbox>
                        </div>
                        <div class="col-md-3">
                            <label class="ml-1" v-if="showSpecialTemplate">{{ $t("res_Label_SpecialTemplate") }}</label>
                            <v-checkbox v-if="showSpecialTemplate" v-model="isSpecialTemplate" label="" solo></v-checkbox>
                        </div>
                        <div class="col-md-6">
                            <label>{{ $t("res_Label_Language") }}<span style="color: red"> *</span></label>
                            <Multiselect class="light-bg" v-model="language" label="name" track-by="id"
                                open-direction="bottom" :placeholder="$t('res_Label_Select')" :options="languages"
                                :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false"
                                :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false"
                                :hide-selected="false" :multiple="false">
                            </Multiselect>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label class="ml-1">{{ $t("res_Label_EnableUAEPass") }}</label>
                            <v-checkbox v-model="isUAEPassEnabled" label="" solo></v-checkbox>
                        </div>
                        <div class="col-md-6">
                            <label class="ml-1">{{ $t("res_Label_EnableESeal") }}</label>
                            <v-checkbox v-model="isEsealEnabled" label="" solo></v-checkbox>
                        </div>
                     </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label class="ml-1">{{ $t("res_Label_SignatureWidth") }}</label>
                            <v-text-field v-model="signatureWidth" type="number" label="" solo></v-text-field>
                        </div>
                        <div class="col-md-6">
                            <label class="ml-1">{{ $t("res_Label_SignatureHeight") }}</label>
                            <v-text-field v-model="signatureHeight" type="number" label="" solo></v-text-field>
                        </div>
                    </div>
                    <!-- for ajman -->
                    <div class="row" v-if="constants.client_version_Id == 'DDA'">
                        <div class="col-md-6">
                            <label class="ml-1">{{ $t("res_Label_ExternalUserCanSign") }}</label>
                            <v-checkbox v-model="canBeSignedByExternalUser" label="" solo></v-checkbox>
                        </div>
                    </div>

                    <!-- for adfd -->
                    <div class="row" v-if="constants.client_version_Id == 'ADFD'">
                        <div class="col-md-12">
                            <label class="ml-1">{{ $t("res_Label_ShowProjectGroup") }}</label>
                            <v-checkbox v-model="showProjectGroup" label="" solo></v-checkbox>
                        </div>
                    </div>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" @click="showEditTemplateDialog = false">{{ $t("res_ButtonText_Cancel")
                    }}</v-btn>
                    <v-btn class="primary" @click="updateSelectedTemplate()">{{ $t("res_ButtonText_Update") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="TemplateDeleteDialog" content-class="small-dialog" width="600">
            <v-card>
                <v-card-title>
                    {{ $t("res_DialogTitle_DeleteTemplate") }}
                </v-card-title>
                <div class="card-body">
                    <label>{{ $t("res_Msgs_DeleteTemplateConfirmation") }}</label>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" @click="TemplateDeleteDialog = false">{{ $t("res_ButtonText_Cancel")
                    }}</v-btn>
                    <v-btn class="primary" @click="deleteTemplate()">{{ $t("res_ButtonText_Delete") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="templateReplaceDialog" content-class="small-dialog" width="600">
            <v-card>
                <v-card-title>{{ $t("res_Label_Replace") }}</v-card-title>
                <div class="card-body">
                    <label>{{ $t("res_Label_AttachTemplate") }}<span style="color: red"> *</span></label>
                    <v-file-input accept=".docx" label="" solo v-model="templateFileReplace" prepend-icon=""></v-file-input>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" @click="templateReplaceDialog = false">{{ $t("res_ButtonText_Cancel")
                    }}</v-btn>
                    <v-btn class="primary" @click="replaceTemplate()">{{ $t("res_ButtonText_Continue") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="openAdvanceTemplateDialog" content-class="small-dialog" width="600">
            <v-card>
                <v-card-title>
                    {{ $t("res_Title_AdvancedManageTemplate") }}
                </v-card-title>

                <EditTemplate :templateId="this.templateId" ref="editTemp"
                    @closeAdvanceEditTemplateDialog="openAdvanceTemplateDialog = false"></EditTemplate>

                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn class="light-blue" @click="openAdvanceTemplateDialog = false">{{ $t("res_ButtonText_Cancel")
                    }}</v-btn>
                    <v-btn class="primary" @click="updateEditTempalateData()">{{ $t("res_ButtonText_Submit") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div v-if="showAddDynamicFormComponent" class=" w-100">
            <DynamicFomrBuilder :structure_id="0" :template_id="dynamicFomrmTemplateId">
            </DynamicFomrBuilder>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import constants from '@/assets/js/constants'
import Multiselect from 'vue-multiselect'
import EditTemplate from '@/components/EditTemplate.vue'
import * as utils from '@/assets/js/common.js'
import Pagination from '@/components/Pagination.vue'
import DynamicFomrBuilder from './DynamicFomrBuilder.vue' 
import TemplatePreview from '../views/admin/TemplatePreview.vue'

export default {
    name: 'ManageTemplate',
    components: {TemplatePreview, Multiselect, EditTemplate, Pagination, DynamicFomrBuilder },
    data() {
        return {
            showPreviewTemplateDialog: false,
            loading: false,
            firstTime: true,
            snackbar_text: '',
            snackbar_show: false,
            isUAEPassEnabled: false,
            isEsealEnabled: false,
            users: [],
            templates: [],
            categories: [],
            privacies: [],
            showAddNewTemplateDialog: false,
            openAdvanceTemplateDialog: false,
            template: {},
            category: '',
            templateId: '',
            templateName: '',
            templateFile: {},
            templateFileReplace: {},
            signatureCount: 0,
            description: '',
            descriptionAr: '',
            tags: '',
            tagsAr: '',
            searchField: '',
            isWorkflow: false,
            isSpecialTemplate:false,
            showSpecialTemplate:false,
            privacy: {},
            showProjectGroup: false,
            signatureWidth: 0,
            signatureHeight: 0,
            canBeSignedByExternalUser: false,
            TemplateDeleteDialog: false,
            templateReplaceDialog: false,
            showEditTemplateDialog: false,
            languages: [],
            language: '',
            dynamicFomrmTemplateId: 0,
            templateHeaders: [
                { text: 'Id', align: ' d-none', value: 'id' },
                { text: this.$t("res_GridHeaders_TemplateName"), value: 'name', width: '30%' },
                { text: this.$t("res_GridHeaders_Category"), value: 'category', width: '10%' },
                { text: this.$t("res_GridHeaders_FileSize"), value: 'fileSize', width: '10%' },
                { text: this.$t("res_GridHeaders_CreatedDate"), value: 'createdDate', width: '20%' },
                { text: this.$t("res_GridHeaders_Actions"), value: 'event', width: '30%', sortable: false }
            ],
            selectedItem: {},
            pagingData: {
                pageSize: 10,
                pageIndex: 0,
                totalCount: 0
            },
            constants: constants,
            showAddDynamicFormComponent: false
        };
    },
    props: {
        structure_id: Number,
    },
    mounted() {
        this.manageTemplateId = 0
        this.getConstantData()
        this.getTemplates(true);
    },
    watch: {
        structure_id(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.manageTemplateId = 0
                this.getConstantData()
                this.getTemplates(true);
            }
        },

    },
    methods:
    {
        getConstantData() {
            this.privacies = constants.privacies
            this.categories = constants.categories
            this.languages = [];
            constants.languages.forEach((language) => {
                if (language.id == 'AR')
                    this.languages.push({ id: 'AR', name: "Arabic" });
                else
                    this.languages.push(language);
            });

            this.categories = this.categories.filter(
                e => {
                    if (e.name === 'Incoming') return false;
                    if (e.name === 'Decree' && constants.isDecreeEnabled == false) return false;
                    if (e.name === 'Circular' && constants.isCircularEnabled == false) return false;
                    if (e.name === 'MOM' && constants.isMOMEnabled == false) return false;
                    return true;
                })
        },
        getTemplates(isResetPaging) {
            if (isResetPaging) {
                this.pagingData.totalCount = 0;
                this.pagingData.pageIndex = 0;
            }

            this.templates = [];
            this.template = {};
            window.showLoading()
            axios.get(constants.baseApiUrl + 'Template/GetTemplatesByStructureId?structureId=' + this.structure_id + '&name=' + this.searchField +
                '&pageIndex=' + this.pagingData.pageIndex + '&pageSize=' + this.pagingData.pageSize)
                .then(response => {
                    if (response.data != null) {
                        if (response.data.length > 0) {
                            this.pagingData.totalCount = response.data[0].totalCount;
                        }

                        this.templates = [];
                        response.data.forEach((template) => {
                            var templateBody = {
                                id: template.id,
                                name: template.itemName,
                                category: this.categories.find(x => x.id == template.categoryId) ? this.categories.find(x => x.id == template.categoryId).name : "",
                                fileSize: template.fileSize,
                                createdDate: utils.dateFormat(template.createdDate),
                                signatureCount: template.signatureCount,
                                descriptionAr: template.descriptionAr,
                                descriptionEn: template.descriptionEn,
                                tags: template.tags,
                                tagsAr: template.tagsAr,
                                privacyId: template.privacyId,
                                isWorkflow: template.isWorkflow,
                                isSpecialTemplate: template.isSpecialTemplate,
                                language: template.language,
                                form: template.form,
                                signatureWidth: (template.width == null ? 0 : template.width),
                                signatureHeight: (template.height == null ? 0 : template.height),
                                isUAEPassEnabled: template.isUAEPassEnabled,
                                isEsealEnabled: template.isEsealEnabled,
                            }

                            this.templates.push(templateBody)
                        });
                    }
                })
                .catch(err => console.warn(err))
                .finally(() => window.hideLoading());
        },
        closeAdvanceEditTemplateDialog() {
            this.openAdvanceTemplateDialog = false
        },
        updateEditTempalateData() {
            this.$refs.editTemp.updatedtemplateData()
        },
        openTemplateReplaceDialog(templateId) {
            this.templateId = templateId
            this.templateReplaceDialog = true
        },
        downloadTemplate(templateId) {
            utils.DownloadFile(constants.baseApiUrl + 'Template/DownloadTemplate?templateId=' + templateId, 'template.docx')
        },
        updateSelectedTemplate() {
            if (this.signatureCount == null
                || this.signatureCount == undefined
                || this.signatureCount == ''
                || this.signatureCount < 0
                || this.signatureCount > constants.templateSignatureCountLimit) {
                window.showAlert(window.translate("res_Msg_SignatureCountError").replace('[[templateSignatureCountLimit]]', constants.templateSignatureCountLimit.toString()), 'warning');
                return false;
            }

            if (this.category != "" && this.templateName != "" && this.privacy != null && this.language) {
                if (this.privacy.id > 0) {
                    var formData = `{"showProjectGroup":${this.showProjectGroup}, "canBeSignedByExternalUser": ${this.canBeSignedByExternalUser}}`
                    //var formData = '{"showProjectGroup": ' + this.showProjectGroup + '}'
                    var template = {
                        Id: this.templateId,
                        CategoryId: this.category.id,
                        PrivacyId: this.privacy.id,
                        StructureId: this.structure_id,
                        TemplateName: this.templateName,
                        SignatureCount: this.signatureCount,
                        Description: this.description,
                        DescriptionAr: this.descriptionAr,
                        Tags: this.tags,
                        TagsAr: this.tagsAr,
                        isWorkflow: this.isWorkflow,
                        isSpecialTemplate: this.isSpecialTemplate,
                        language: this.language.id,
                        form: formData,
                        isUAEPassEnabled:this.isUAEPassEnabled,
                        isEsealEnabled: this.isEsealEnabled,
                    }

                    if (this.signatureWidth != null && this.signatureWidth != undefined && this.signatureHeight != '')
                        template.SignatureWidth = parseInt(this.signatureWidth)

                    if (this.signatureHeight != null && this.signatureHeight != undefined && this.signatureHeight != '')
                        template.SignatureHeight = parseInt(this.signatureHeight)

                    //
                    axios.post(constants.baseApiUrl + 'Template/UpdateTemplate', template)
                        .then(response => {
                            if (response.data != null) {
                                window.showAlert(this.$t("res_Msg_TemplatedAdded"), "success")

                                this.showEditTemplateDialog = false
                                this.searchField = ''
                                this.getTemplates()
                            }
                        })
                        .catch(err => console.warn(err))
                }
                else {
                    window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning');
                }
            }
            else {
                window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning');
            }
        },
        replaceTemplate() {
            if (this.templateFileReplace.size != undefined) {
                this.readFile(this.templateFileReplace, (fileBytes) => {
                    var template = {
                        Id: this.templateId,
                        ItemBytes: fileBytes,
                        FileName: this.templateFileReplace.name,
                    }

                    if (!template.FileName.endsWith('.docx')) {
                        return  window.showAlert(this.$t("res_Msgs_ErrorTemplate"), "error") 
                    } 
                    
                    axios.post(constants.baseApiUrl + 'Template/ReplaceTemplateById', template, { headers: constants.headers })
                        .then(response => {
                            if (response.data != null) {
                                window.showAlert(this.$t("res_Msgs_TemplateReplaced"), "success")
                                this.templateReplaceDialog = false
                                this.getTemplates()
                            }
                        })
                        .catch(err => console.warn(err))
                });
            }
        },
        openAdvanceTemplateEdit(templateId) {
            this.templateId = templateId
            this.openAdvanceTemplateDialog = true
        },
        OpenAddNewTemplateDialog() {
            this.category = ""
            this.templateName = ""
            this.templateFile = {}
            this.showAddNewTemplateDialog = true
        },
        addNewTemplate() {
            if (this.category != "" && this.templateName != "" && this.templateFile.size != undefined) {
                this.readFile(this.templateFile, (fileBytes) => {
                    var template = {
                        CategoryId: this.category.id,
                        StructureId: this.structure_id,
                        FileSize: this.templateFile.size,
                        TemplateName: this.templateName,
                        ItemBytes: fileBytes,
                        FileName: this.templateFile.name,
                    }

            if (!template.FileName.endsWith('.docx')) {
                    return  window.showAlert(this.$t("res_Msgs_ErrorTemplate"), "error") 
                    } 
                    window.showLoading();
                    axios.post(constants.baseApiUrl + 'Template/AddNewTemplate', template, { headers: constants.headers })
                        .then(response => {
                            if (response.data != null) {
                                window.showAlert(this.$t("res_Msgs_TemplateAdded"), "success")
                                this.showAddNewTemplateDialog = false
                                this.getTemplates()
                            }
                        })
                        .catch(err => console.warn(err))
                        .finally(() => {
                            window.hideLoading();
                        })
                });
            }
            else {
                window.showAlert(this.$t('res_Msgs_FillRequired'), 'warning')
            }
        },
        openEditTemplateDialog(templateRow) {
            this.templateId = templateRow.id
            this.category = { name: templateRow.category, id: this.categories.find(x => x.name == templateRow.category).id }
            if (templateRow.privacyId != null)
                this.privacy = { id: templateRow.privacyId, name: this.privacies.find(x => x.id == templateRow.privacyId).name }
            this.templateName = templateRow.name
            this.signatureCount = templateRow.signatureCount
            this.tags = templateRow.tags
            this.tagsAr = templateRow.tagsAr
            this.description = templateRow.descriptionEn
            this.descriptionAr = templateRow.descriptionAr
            this.isWorkflow = templateRow.isWorkflow
            this.isSpecialTemplate = templateRow.isSpecialTemplate
            this.language = this.languages.find(x => x.id == templateRow.language)
            this.signatureWidth = (templateRow.signatureWidth == null ? 0 : templateRow.signatureWidth)
            this.signatureHeight = (templateRow.signatureHeight == null ? 0 : templateRow.signatureHeight)
            this.isUAEPassEnabled = templateRow.isUAEPassEnabled
            this.isEsealEnabled = templateRow.isEsealEnabled;
            if(constants.enableSpecialTemplate){
                this.showSpecialTemplate = true;
            }
            else{
                this.showSpecialTemplate = false;
            }
            this.showEditTemplateDialog = true

            // for adfd
            if (constants.client_version_Id == 'ADFD') {
                if (templateRow.form != null && templateRow.form != undefined && templateRow.form != '') {
                    var templateJson = JSON.parse(templateRow.form);
                    this.showProjectGroup = templateJson.showProjectGroup;
                }
                else{
                    this.showProjectGroup = false;
                }   
            }
            if (constants.client_version_Id == 'DDA'){
                if (templateRow.form != null && templateRow.form != undefined && templateRow.form != '') {
                    var templateJson = JSON.parse(templateRow.form);
                    this.canBeSignedByExternalUser = templateJson.canBeSignedByExternalUser;
                }
                else{
                    this.canBeSignedByExternalUser = false;
                }  
            }
        },
        openTemplateDelegionDialog(templateId) {
            this.templateId = templateId;
            this.TemplateDeleteDialog = true;
        },
        deleteTemplate() {
            axios.get(constants.baseApiUrl + 'Template/DeleteTemplateById?templateId=' + this.templateId, { headers: constants.headers })
                .then(response => {
                    if (response.data && response.data.success) { 
                         window.showAlert(this.$t('res_Msgs_TemplateDeletedSuccess'), "success");
                         this.TemplateDeleteDialog = false
                         this.getTemplates()
                    }
                    else
                    {
                        if(response.data && response.data.msg && response.data.msg.length > 0)
                        {
                            window.showAlert(this.$t(response.data.msg), "error");
                        }
                        else
                        {
                            window.showAlert(this.$t('res_Msgs_TemplateDeletedFail'), "error");
                        } 
                    }
                })
                .catch(err => console.warn(err))
        },
        async readFile(file, successHandler) {
            var reader = new FileReader();
            var fileByteArray = [];
            reader.readAsArrayBuffer(file);
            reader.onloadend = function (evt) {
                if (evt.target.readyState == FileReader.DONE) {
                    var arrayBuffer = evt.target.result,
                        array = new Uint8Array(arrayBuffer);
                    for (var i = 0; i < array.length; i++) {
                        fileByteArray.push(array[i]);
                    }

                    successHandler(fileByteArray);
                }
            }
        },
        dateFormat: function (inputDate, format) {
            const date = new Date(inputDate)
            const day = date.getDate()
            const month = date.getMonth() + 1
            const year = date.getFullYear()

            format = format.replace("MM", month.toString().padStart(2, "0"))

            if (format.indexOf("yyyy") > -1)
                format = format.replace("yyyy", year.toString());
            else if (format.indexOf("yy") > -1)
                format = format.replace("yy", year.toString().substr(2, 2))

            format = format.replace("dd", day.toString().padStart(2, "0"))
            return format
        },
        selectItem(item) {
            this.selectedItem = item
        },
        unSelectItem(item) {
            this.selectedItem = false
        },
        pageIndexChanged(pagingData) {
            this.pagingData.pageSize = pagingData.pageSize;
            this.pagingData.pageIndex = pagingData.pageIndex;

            this.getTemplates();
        },
        showDynamicFormBuilderComponent(templateId) {
            this.dynamicFomrmTemplateId = templateId;
            if (this.showAddDynamicFormComponent)
                this.showAddDynamicFormComponent = false;
            setTimeout(() => {
                this.showAddDynamicFormComponent = true;

            }, 200);
        },
        openPreviewTemplateDialog(id) {
                
				this.templateId = id;
				this.showPreviewTemplateDialog = true;
		},
		closePreviewTemplateDialog() {
                        
				this.templateId = 0;
				this.showPreviewTemplateDialog = false;
		},
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

.v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
     margin-left: 3px !important;

}


</style>